import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "interstitialCtaItem" }
const _hoisted_2 = { class: "text" }
const _hoisted_3 = { class: "titleAndTag" }
const _hoisted_4 = { class: "tag" }
const _hoisted_5 = { class: "title" }
const _hoisted_6 = { class: "linkWrapper" }
const _hoisted_7 = ["href", "aria-label"]
const _hoisted_8 = { class: "image" }
const _hoisted_9 = ["srcset"]
const _hoisted_10 = ["srcset"]
const _hoisted_11 = ["srcset"]
const _hoisted_12 = ["src"]
const _hoisted_13 = {
  key: 1,
  src: "/assets/images/Placeholder.png"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.result?.category), 1),
        _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.result?.title), 1)
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("a", {
          href: _ctx.result.url,
          class: "ctaLink",
          "aria-label": _ctx.result?.title
        }, [
          _createElementVNode("span", null, _toDisplayString(_ctx.result?.customButtonLabel
                ? _ctx.result?.customButtonLabel
                : _ctx.$t("Web.Containers.ReadMore")), 1)
        ], 8, _hoisted_7)
      ])
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("picture", null, [
        _createElementVNode("source", {
          srcset: _ctx.result?.imageDesktop,
          media: "(min-width: 767px)"
        }, null, 8, _hoisted_9),
        _createElementVNode("source", {
          srcset: _ctx.result?.imageTablet,
          media: "(min-width: 500px)"
        }, null, 8, _hoisted_10),
        _createElementVNode("source", {
          srcset: _ctx.result?.imageMobile,
          media: "(min-width: 0px)"
        }, null, 8, _hoisted_11),
        (_ctx.result?.imageDesktop)
          ? (_openBlock(), _createElementBlock("img", {
              key: 0,
              src: _ctx.result?.imageDesktop,
              alt: "",
              role: "presentation"
            }, null, 8, _hoisted_12))
          : (_openBlock(), _createElementBlock("img", _hoisted_13))
      ])
    ])
  ]))
}